// extracted by mini-css-extract-plugin
export var gridWrapper = "index-module--gridWrapper--470bf";
export var root = "index-module--root--8c3b9";
export var teacherImage = "index-module--teacherImage--143c9";